var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 214.96 85.62",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m121.56 36.07-6-11.91h-4.68v11.91h-9.14v-35.46h17.75c7.87 0 12.34 5.21 12.34 11.8 0 6.17-3.73 9.46-7.07 10.63l7.22 13zm1-23.71c0-2.45-2-3.77-4.41-3.77h-7.23v7.6h7.23c2.45 0 4.42-1.33 4.42-3.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155 36.07v-27.48h-10v-8h29v8h-9.89v27.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189 36.07v-35.46h26v8h-16.89v5.52h16.48v8h-16.48v6h16.89v8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69 0a18.34 18.34 0 1 0 18.29 18.34 18.34 18.34 0 0 0 -18.29-18.34zm0 27.83a9.5 9.5 0 1 1 9.49-9.49 9.49 9.49 0 0 1 -9.49 9.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.62 8.58v-7.98h-26v53.31a16.19 16.19 0 1 0 9.15 0v-31.83h16.47v-8h-16.47v-5.5zm-13.75 60.85a7.69 7.69 0 1 1 -7.69-7.68 7.69 7.69 0 0 1 7.69 7.68z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/16.31edb52f6ec1bc91ed0aa9bb00940c1d.svg";
export { ForwardRef as ReactComponent };